<template>
  <div>
    <home-desktop v-if="screenType === 'desktop'"></home-desktop>
    <home-mobile v-else-if="screenType ==='mobile'"></home-mobile>
    <home-tablet v-else></home-tablet>
  </div>
</template>

<script>
import HomeDesktop from "@/components/Pages/Desktop/Home/HomeDesktop";
import HomeMobile from "@/components/Pages/Mobile/Home/HomeMobile";
import HomeTablet from "@/components/Pages/Tablet/Home/HomeTablet";

export default {
  name: 'HomeMain',
  components: {HomeTablet, HomeMobile, HomeDesktop},
  data() {
    return {
      screenType: window.screen.width < 500 ? 'mobile' : window.screen.width < 1000 ? 'tablet' : 'desktop'
    }
  }
}
</script>
<style>
</style>